export const GET_ORDERS_REQUEST = 
"GET_ORDERS_REQUEST"
export const GET_ORDERS_SUCCESS = 
"GET_ORDERS_SUCCESS"
export const GET_ORDERS_FAIL = 
"GET_ORDERS_FAIL" 

export const GET_ORDERS_INPROGRESS_REQUEST = 
"GET_ORDERS_INPROGRESS_REQUEST"
export const GET_ORDERS_INPROGRESS_SUCCESS = 
"GET_ORDERS_INPROGRESS_SUCCESS"
export const GET_ORDERS_INPROGRESS_FAIL = 
"GET_ORDERS_INPROGRESS_FAIL" 

export const GET_ORDERS_PENDING_REQUEST = 
"GET_ORDERS_PENDING_REQUEST"
export const GET_ORDERS_PENDING_SUCCESS = 
"GET_ORDERs_PENDING_SUCCESS"
export const GET_ORDERS_PENDING_FAIL = 
"GET_ORDERS_PENDING_FAIL" 

export const GET_ORDERS_BY_ID_REQUEST = 
"GET_ORDERS_BY_ID_REQUEST"
export const GET_ORDERS_BY_ID_SUCCESS = 
"GET_ORDERS_BY_ID_SUCCESS"
export const GET_ORDERS_BY_ID_FAIL = 
"GET_ORDERS_BY_ID_FAIL" 

export const CREATE_ORDERS_REQUEST = 
"CREATE_ORDERS_REQUEST"
export const CREATE_ORDERS_SUCCESS = 
"CREATE_ORDERS_SUCCESS"
export const CREATE_ORDERS_FAIL = 
"CREATE_ORDERS_FAIL" 

export const GET_ORDER_DETAILS_REQUEST = 
"GET_ORDER_DETAILS_REQUEST"
export const GET_ORDERS_DETAILS_SUCCESS = 
"GET_ORDERS_DETAILS_SUCCESS"
export const GET_ORDERS_DETAILS_FAIL = 
"GET_ORDERS_DETAILS_FAIL" 

export const CREATE_ORDERS_DETAILS_REQUEST = 
"CREATE_ORDERS_DETAILS_REQUEST"
export const CREATE_ORDERS_DETAILS_SUCCESS = 
"CREATE_ORDERS_DETAILS_SUCCESS"
export const CREATE_ORDERS_DETAILS_FAIL = 
"CREATE_ORDERS_DETAILS_FAIL" 

export const GET_ORDER_REPORTS_REQUEST = 
"GET_ORDER_REPORTS_REQUEST"
export const GET_ORDERS_REPORTS_SUCCESS = 
"GET_ORDERS_REPORTS_SUCCESS"
export const GET_ORDERS_REPORTS_FAIL = 
"GET_ORDERS_REPORTS_FAIL" 

export const GET_ORDER_REPORTS_BY_YEAR_REQUEST = 
"GET_ORDER_REPORTS_BY_YEAR_REQUEST"
export const GET_ORDERS_REPORTS_BY_YEAR_SUCCESS = 
"GET_ORDERS_REPORTS_BY_YEAR_SUCCESS"
export const GET_ORDERS_REPORT_BY_YEAR_FAIL = 
"GET_ORDERS_REPORTS_BY_YEAR_FAIL" 

export const GET_ORDER_REPORTS_BY_MONTH_REQUEST = 
"GET_ORDER_REPORTS_BY_MONTH_REQUEST"
export const GET_ORDERS_REPORTS_BY_MONTH_SUCCESS = 
"GET_ORDERS_REPORTS_BY_MONTH_SUCCESS"
export const GET_ORDERS_REPORT_BY_MONTH_FAIL = 
"GET_ORDERS_REPORTS_BY_MONTH_FAIL" 

export const GET_ORDER_REPORTS_BY_WEEK_REQUEST = 
"GET_ORDER_REPORTS_BY_WEEK_REQUEST"
export const GET_ORDERS_REPORTS_BY_WEEK_SUCCESS = 
"GET_ORDERS_REPORTS_BY_WEEK_SUCCESS"
export const GET_ORDERS_REPORT_BY_WEEK_FAIL = 
"GET_ORDERS_REPORTS_BY_WEEK_FAIL" 

export const GET_ORDER_REPORTS_OF_LAST_WEEK_REQUEST = 
"GET_ORDER_REPORTS_OF_LAST_WEEK_REQUEST"
export const GET_ORDERS_REPORTS_OF_LAST_WEEK_SUCCESS = 
"GET_ORDERS_REPORTS_OF_LAST_WEEK_SUCCESS"
export const GET_ORDERS_REPORT_OF_LAST_WEEK_FAIL = 
"GET_ORDERS_REPORTS_OF_LAST_WEEK_FAIL" 

export const GET_ORDER_TOTALS_REQUEST = 
"GET_ORDER_TOTALS_REQUEST"
export const GET_ORDERS_TOTALS_SUCCESS = 
"GET_ORDERS_TOTALS_SUCCESS"
export const GET_ORDERS_TOTALS_FAIL = 
"GET_ORDERS_TOTALS_FAIL" 


export const GET_RECENT_ORDER_LOCATION =
'GET_RECENT_ORDER_LOCATION'
export const GET_RECENT_ORDER_LOCATION_SUCCESS =
'GET_RECENT_ORDER_LOCATION_SUCCESS'
export const GET_RECENT_ORDER_LOCATION_FAIL =
'GET_RECENT_ORDER_LOCATION_FAIL'